import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BaseDataAirOfflineBooking, OfflineBookingWrapper, OfflineBookingList, OfflineBookingProperties, OfflineBookingRights, OfflineBookingAllList, CheckOfflineTicket } from '../Models/OfflineBookingProperties';
import { AirportCityProperties } from '../Models/ActiveClasses';
import { PassengerCreationResponse } from '../Models/BookingPassengerTicketIssuanceProperties';
import { ChatMessages, OfflineBookingRequestGet } from '../Models/OfflineBookingRequestProperties';
import { OfflineBookingNewProperties, ResponseToClient } from '../Models/OfflineNewProperties';

@Injectable({
  providedIn: 'root'
})
export class OfflineRequestService {
  baseUrl = environment.baseUrl;
  backSystemBaseUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(private http: HttpClient) { }



  getOfflineBookingAllData(obj): Observable<OfflineBookingAllList[]> {
    return this.http.post<OfflineBookingAllList[]>(this.baseUrl + '/OfflineBooking/GetOfflineBookingAllData', obj, this.httpOptions)
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }

  saveOnlineTktRequest(obj): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/SaveOnlineTicketRequest', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }

  UpdateAgencyBranchPendingCreditSOffline(newcreditlimit): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/UpdatePendingCreditsOffline/' + newcreditlimit, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getAirOfflineBookingBaseData(): Observable<BaseDataAirOfflineBooking> {
    return this.http.get<BaseDataAirOfflineBooking>(this.baseUrl + '/OfflineBooking/GetBaseDataAirOfflineBooking')
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }

  getTicketRequestList(userId, agencyId): Observable<OfflineBookingAllList[]> {
    return this.http.get<OfflineBookingAllList[]>(this.baseUrl + '/OfflineBooking/GetTicketRequestList/' + userId + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  getVoidRequestList(userId, agencyId): Observable<OfflineBookingList[]> {
    return this.http.get<OfflineBookingList[]>(this.baseUrl + '/OfflineBooking/GetVoidRequestList/' + userId + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  getRefundRequestList(userId, agencyId): Observable<OfflineBookingList[]> {
    return this.http.get<OfflineBookingList[]>(this.baseUrl + '/OfflineBooking/GetRefundRequestList/' + userId + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }

  getRequestListManager(obj): Observable<OfflineBookingAllList[]> {
    return this.http.post<OfflineBookingAllList[]>(this.baseUrl + '/OfflineBooking/GetTicketRequestListManager', obj, this.httpOptions)
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  GetTicketRequestOfflineListManager(obj): Observable<OfflineBookingAllList[]> {
    return this.http.post<OfflineBookingAllList[]>(this.baseUrl + '/OfflineBooking/GetTicketRequestOfflineListManager', obj, this.httpOptions)
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  getVoidRequestListManager(userId, agencyId): Observable<OfflineBookingList[]> {
    return this.http.get<OfflineBookingList[]>(this.baseUrl + '/OfflineBooking/GetVoidRequestListManager/' + userId + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  getRefundRequestListManager(userId, agencyId): Observable<OfflineBookingList[]> {
    return this.http.get<OfflineBookingList[]>(this.baseUrl + '/OfflineBooking/GetRefundRequestListManager/' + userId + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  //getManagerRequestList(userId, agencyId): Observable<OfflineBookingList[]> {
  //  return this.http.get<OfflineBookingList[]>(this.baseUrl + '/OfflineBooking/GetManagerOfflineBookingList/' + userId + "/" + agencyId)
  //    .pipe(map((data: any) => {
  //      return data;
  //    }), catchError(error => { console.log(error); return throwError(error); }))
  //}

  saveOfflineTktRequest(obj: OfflineBookingWrapper): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/SaveOfflineTktRequest', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  //UpdateOfflineTktRequest(offlineBookingId): Observable<boolean> {

  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/UpdateOnlineTicketRequest/' + offlineBookingId, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}
  saveOfflineVoidRefundRequest(obj): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/SaveOfflineVoidRefundRequest', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  approveRejectOfflineVoidRefund(obj): Observable<boolean> {
    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/ApproveRejectOfflineVoidRefund', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  //10-June-24
  InprogressTicket(offlineBookingId): Observable<CheckOfflineTicket> {
    return this.http.get<CheckOfflineTicket>(this.baseUrl + '/OfflineBooking/CheckTagOfInprogress/' + offlineBookingId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  InprogressTicketupdate(offlineBookingId): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.get<boolean>(this.baseUrl + '/OfflineBooking/UpdateTagOfInprogress?offlineBookingId=' + offlineBookingId, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  getOfflineRequestById(offlineBookingRequestGet: OfflineBookingRequestGet): Observable<OfflineBookingWrapper> {
    return this.http.post<OfflineBookingWrapper>(this.baseUrl + '/OfflineBooking/GetOfflineBookingById', offlineBookingRequestGet, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  ChatMessagesCommunicationOfflineTicket(chatForm: FormData): Observable<ChatMessages[]> {
    return this.http.post<ChatMessages[]>(this.baseUrl + '/OfflineBooking/ChatMessagesCommunicationOfflineTicket', chatForm).pipe(
      map((response) => {
        return response;
      }), catchError(error => { return throwError(error); }));
  }
  ChatMessagesCommunicationOfflineTicketGet(offlineBookingId: number): Observable<ChatMessages[]> {
    return this.http.get<ChatMessages[]>(this.baseUrl + '/OfflineBooking/ChatMessagesCommunicationOfflineTicketGet?offlineBookingId=' + offlineBookingId).pipe(
      map((response) => {
        return response;
      }), catchError(error => { return throwError(error); }));
  }
  CreateOfflineTicketIssueRequest(offlineTicketRequestProp: FormData): Observable<boolean> {
    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/CreateOfflineTicketIssueRequest', offlineTicketRequestProp).pipe(
      map((response) => {
        this.showSpinner.next(false);
        return response;
      }), catchError(error => { this.showSpinner.next(false); return throwError(error); }));
  }
  //end


  //UpdateFare(obj): Observable<boolean> {
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/UpdateFare', obj, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}
  //QuoteFare(obj): Observable<boolean> {
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/QuoteFare', obj, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}
  //IssueTickets(supplierObj: OfflineBookingProperties): Observable<boolean> {
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/ChangeBookingStatusOkIssue', supplierObj, this.httpOptions)
  //  .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}

  //Approve(obj): Observable<boolean> {
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/ChangeBookingStatusApproved', obj, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}

  //update(supplierObj): Observable<boolean> {
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/updateOfflineBooking', supplierObj, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}
  //discard(supplierObj): Observable<boolean> {
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/DiscardOfflineBooking', supplierObj, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}
  //reject(supplierObj): Observable<boolean> {
  //  console.log(supplierObj);
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/RejectOfflineBooking', supplierObj, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}
  //refund(supplierObj): Observable<boolean> {
  //  console.log(supplierObj);
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/VoidCancelOfflineBooking', supplierObj, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}
  //voidCancel(supplierObj): Observable<boolean> {
  //  console.log(supplierObj);
  //  this.showSpinner.next(true);
  //  return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/VoidCancelOfflineBooking', supplierObj, this.httpOptions)
  //    .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  //}
  CheckOfflineRequestRight(userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/OfflineBooking/CheckOfflineRequestRight/' + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        console.log(error);
        return throwError(error);
      }))
  }
  CheckOfflineRequestAgaintAgencyAndUserId(agencyId, userId): Observable<OfflineBookingRights> {
    return this.http.get<OfflineBookingRights>(this.baseUrl + '/OfflineBooking/CheckOfflineRequestRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        console.log(error);
        return throwError(error);
      }))
  }


  ApproveOfflineVoidRefundRequest(obj): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/UpdateChargesOfRefundRequest', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }

  //20-jan-24

  ApplyRevenueOnTicket(obj: OfflineBookingWrapper): Observable<OfflineBookingWrapper> {

    this.showSpinner.next(true);
    return this.http.post<OfflineBookingWrapper>(this.baseUrl + '/OfflineBooking/ApplyRevenueOnTicket', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  //06-feb-24
  approveRejectOfflineTicketRequest(obj): Observable<PassengerCreationResponse> {

    // this.showSpinner.next(true);
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/OfflineBooking/ApproveRejectOfflineTicketRequest', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  //end

  getOfflineBookingbyPNRAllData(obj): Observable<OfflineBookingAllList[]> {
    return this.http.post<OfflineBookingAllList[]>(this.baseUrl + '/OfflineBooking/GetOfflineBookingbyPNRAllData', obj, this.httpOptions)
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  EmailMesage(chatMessage): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/EmailMessage', chatMessage)
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }

  UpdateOfflineTktRequest(offlineBookingId, userId): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/OfflineBooking/UpdateOnlineTicketRequest/' + offlineBookingId + '/' + userId, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  CreateOrUpdateOfflineBooking(obj): Observable<ResponseToClient> {
    return this.http.post<ResponseToClient>(this.baseUrl + '/OfflineBooking/CreateOrUpdateOfflineBooking', obj)
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  }
  GetOfflineBookingById(booking): Observable<OfflineBookingNewProperties> {
    return this.http.post<OfflineBookingNewProperties>(this.baseUrl + '/OfflineBooking/GetOfflineBookingByIdNew', booking, this.httpOptions)
      .pipe(map((data: any) => {
        //  console.log(data);
        return data;
      }), catchError(error => { console.log(error); return throwError(error); }))
  
  }
  RejectRequestOfflineBooking(obj): Observable<ResponseToClient> {

    // this.showSpinner.next(true);
    return this.http.post<ResponseToClient>(this.baseUrl + '/OfflineBooking/RejectRequestOfflineBooking', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  ApplyRevenueOnTicketPassengerWise(obj: OfflineBookingNewProperties): Observable<OfflineBookingNewProperties> {

    this.showSpinner.next(true);
    return this.http.post<OfflineBookingNewProperties>(this.baseUrl + '/OfflineBooking/ApplyRevenueOnTicketPassengerWise', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
}
